import React, { useEffect, useRef } from "react";

const PDFViewer = ({ pdfData }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    if (!pdfData) return;

    // Convert the data to a Blob and create a URL
    const blob = new Blob([pdfData], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    // Assign the Blob URL to the iframe
    // iframeRef.current.src = url;

    const downloadLink = document.createElement('a');
    downloadLink.href = url;
    downloadLink.download = 'Bardwood_Agreement.pdf';  // Specify the file name for download
    downloadLink.click();  // Automatically triggers the download



    // Clean up URL on component unmount
    return () => URL.revokeObjectURL(url);
  }, [pdfData]);

};

export default PDFViewer;
